'use client';

import { useState } from 'react';
import SpecItem from './spec-item';
import Temperature from './temperature';
import cn from 'clsx';
import s from './product-specs.module.css';

const ProductSpecs = ({
    productWeight,
    fabricContent,
    temperature,
    ridingConditions,
    sku,
    fit,
}) => {
    const [isCentigrade, setIsCentigrade] = useState(true);

    let parsedRidingConditions = [];
    try {
        parsedRidingConditions = JSON.parse(ridingConditions)
    } catch(error) {
        console.info('Could not parse riding conditions')
    }

    return (
        <div className={cn(s.specs, s.region)}>
            <div className={s.stack}>
                <h3 className="mmds-component-one-detail">Specifications</h3>
                <dl>
                    <hr className="divider" />
                    <SpecItem label="Product Weight" value={productWeight} />
                    <SpecItem
                        label="Main Fabric Content"
                        value={fabricContent}
                    />
                    <SpecItem label="Fit" value={fit} />
                </dl>
            </div>
            <div className={s.stack}>
                <h3 className="mmds-component-one-detail">Usage</h3>
                <dl>
                    <hr className="divider" />
                    <Temperature
                        temperature={temperature}
                        isCentigrade={isCentigrade}
                        setIsCentigrade={setIsCentigrade}
                    />
                    <SpecItem
                        label="Riding Conditions"
                        value={parsedRidingConditions.join(', ')}
                    />
                    <SpecItem label="SKU" value={sku} />
                </dl>
            </div>
        </div>
    );
};

export default ProductSpecs;
